import React from 'react';
import Tab from '@material-ui/core/Tab';
import {FormControl, MenuItem, Select, IconButton} from '@material-ui/core';
import Circle from '@material-ui/icons/FiberManualRecord';
import Close from '@material-ui/icons/Close';
import {StyledTabs} from '../../../../../../components/FlowConfigurationInputs';
import Info from '../../shortCutSection/Info';
import './DetailTabs.css';

const DetailTabs = ({automName, tabFilter, setTabFilter, detailTabs, setDetailTabs}) => {

    let tabCount = 8;
    const handleChange = (event, newValue) => {
        setTabFilter(newValue);
    };

    const handleTabClose = (e, index) => {
        e.stopPropagation();
        detailTabs.splice(index, 1);
        if (index + 1 === tabFilter) setTabFilter(index);
        setDetailTabs([...detailTabs]);
    }

    return (
        <div className="new-flow-tabs">
            <StyledTabs value={tabFilter} onChange={handleChange}>
                <Tab value={0} label={
                    <Info value={automName}>
                        <span className='content-overflow' style={{width: 100}}>
                            {automName}
                        </span>
                    </Info>
                }/>
                {detailTabs?.slice(0, tabCount)?.map((tab, index) => (
                    <Tab key={index} value={index + 1} label={
                        <div className="detailtab-label">
                            <Circle
                                style={{fontSize: 18, position: 'absolute', left: 0, marginTop: 1, color: tab.color}}/>
                            <span>&nbsp;&nbsp;{tab.name}</span>
                            <IconButton size='small' onClick={e => handleTabClose(e, index)}
                                        style={{
                                            position: 'absolute',
                                            minWidth: 20,
                                            marginTop: -5,
                                            right: 0,
                                            background: 'white'
                                        }}>
                                <Close fontSize='small' style={{fontSize: 15}}/>
                            </IconButton>
                        </div>}/>
                ))}
                {detailTabs?.length > tabCount &&
                <FormControl>
                    <Select value={tabFilter} onChange={e => handleChange(e, e.target.value)}>
                        {detailTabs?.slice(tabCount, detailTabs.length).map((tab, index) => (
                            <MenuItem key={index} value={index + tabCount + 1}>{tab.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                }
            </StyledTabs>
        </div>
    )
}
export default DetailTabs;
